import { useMemo } from 'react';

import { LAMINATE_REGEX } from '~/core/constants/materialType';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedMaterial } from '~/redux/slices/material';

export const useIsLaminateSelected = (): boolean => {
  const selectedMaterial = useAppSelector(selectSelectedMaterial);

  return useMemo(() => {
    if (!selectedMaterial?.description) {
      return false;
    }

    return LAMINATE_REGEX.test(selectedMaterial.description);
  }, [selectedMaterial?.description]);
};
